import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { books } from "./booksData";
import { Nav, Error, Ul, Div, Title, Subtitle, H2, BookH2 } from "./elements";

const createId = (text) => {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, "")
        .replace(/\s+/g, "-");
};

export const Book = (props) => {
    const { slug } = useParams();
    let page = "";

    if (slug in books) {
        page = books[slug];
    }

    useEffect(() => {
        if (page !== "") {
            document.title = `${page.title} | Duane Hilton`;
        }
        window.scrollTo(0, 0);
    }, []);

    let content = <Error />;
    if (page !== "" && !page.blank) {
        const href = `https://www.amazon.com/s?k=${page.title.replace(
            " ",
            "+"
        )}+${page.author.replace(" ", "+")}`;

        const topicText = page.topic
            .replace("History", "History/Biography/Memoir")
            .replace("Philosophy", "Philosophy/Ethics");
        const topicId = createId(topicText);
        const categoryLink = `/books/#${topicId}`;

        content = (
            <Div>
                <Nav />
                <Title>{page.title}</Title>
                <Subtitle>by {page.author}</Subtitle>
                <p style={{ marginTop: "-1.5rem", color: "#777" }}>
                    Category: <Link to={categoryLink}>{topicText}</Link>
                </p>
                <div>{page.body}</div>
                <p>
                    Get this book on <a href={href}>Amazon</a>.
                </p>
            </Div>
        );
    }

    return content;
};

export const Books = () => {
    useEffect(() => {
        document.title = "Books | Duane Hilton";
        // check if document has a hash
        if (window.location.hash) {
            const hash = window.location.hash.substring(1);
            const element = document.getElementById(hash);
            if (element) {
                element.scrollIntoView();
            }
        } else {
            window.scrollTo(0, 0);
        }
    }, []);

    let topics = [];
    for (let k in books) {
        topics.push(books[k].topic);
    }
    topics = [...new Set(topics.sort())];
    topics = topics.reverse();
    let booksByTopic = [];

    for (let i = 0; i < topics.length; i++) {
        let booksList = Object.keys(books)
            .filter((k) => books[k].topic === topics[i])
            .sort((a, b) => a.localeCompare(b))
            .map((k) => {
                if (books[k].blank) {
                    return (
                        <li key={k}>
                            {books[k].title} by {books[k].author}
                        </li>
                    );
                } else {
                    return (
                        <li key={k}>
                            <Link to={"/books/" + k}>{books[k].title}</Link> by{" "}
                            {books[k].author}
                        </li>
                    );
                }
            });
        const topicText = topics[i]
            .replace("History", "History/Biography/Memoir")
            .replace("Philosophy", "Philosophy/Ethics");
        const topicId = createId(topicText);

        booksByTopic.push(
            <div key={topics[i]}>
                <BookH2 id={topicId}>
                    <a
                        href={`#${topicId}`}
                        style={{ textDecoration: "none", color: "inherit" }}
                    >
                        {topicText}
                    </a>
                </BookH2>
                <Ul>{booksList}</Ul>
            </div>
        );
    }

    return (
        <Div>
            <Nav />
            <H2>Quotes and ideas from my booklist</H2>
            {booksByTopic}
        </Div>
    );
};
